import {AppState} from "@/state/rootReducer";

export function getCurrentSelectedBusinessUnitId(state: AppState): string {
    return (
        state.application.currentSelectedBusinessUnitId ||
        state.application.userSettings.defaultBusinessUnitId ||
        state.application.selectedClientConcept.rootGroupId
    );
}

export function getCurrentSelectedClientConceptPk(state: AppState): number {
    return state.application.selectedClientConcept.clientConcept_PK;
}
